import { Component, effect, OnInit } from '@angular/core';
import { theme } from '../../../data/theme';
import { HomepageService } from '@app/_services/homepage.service';
import * as _ from 'lodash';
import { SiteService } from '@app/_services';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { NewsletterComponent } from './components/newsletter/newsletter.component';
import { ContactsComponent } from './components/contacts/contacts.component';
import { LinksComponent } from './components/links/links.component';
import { NgFor, NgIf, KeyValuePipe } from '@angular/common';
import { GeneralNavigationService } from '@app/_components/root/general-navigation/general-navigation.service';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: true,
    imports: [NgFor, LinksComponent, ContactsComponent, NgIf, NewsletterComponent, MatIconModule, KeyValuePipe, TranslateModule]
})
export class FooterComponent implements OnInit {
    theme = theme;
    staticPages: any = {};
    siteCompany;
    thisYear = new Date().getFullYear();

    background = '#20324e';
    foreground = '#ffffff';
    hideFooter = false;

    constructor(private homepageService: HomepageService, public siteService: SiteService, private generalNavigationService: GeneralNavigationService) {
        this.homepageService.getPages().subscribe(response => {
            if (response.pages) {
                _.forEach(response.pages, (page) => {
                    this.staticPages[page.section] = []
                });
                _.forEach(response.pages, (page) => {
                    this.staticPages[page.section].push(page)
                });
            }

            if (response.companyData) this.siteCompany = response.companyData;

        });

        effect(() => {
            this.hideFooter = Boolean(this.generalNavigationService.menuItems.length);
        });
    }
    ngOnInit(): void {
        this.background = this.siteService.siteSetting?.footer?.backgroundColor;
        this.foreground = this.siteService.siteSetting?.footer?.foregroundColor;
    }
}
